import { Videos } from '@shared/types/Videos';
import { useVideosStore } from '../stores/VideosStore';

export const initVideos = (videos: Videos) => {
  useVideosStore().$patch((state) => {
    state.profileVideo = videos?.profile;
    state.aboutMeVideo = videos.about;
  });
};
